var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","to":tab.path}},[_vm._v(_vm._s(tab.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }